import React from 'react'
import { Icon, IconNotebook, palette } from '@centivo/react-components'

import styled from 'styled-components'

const CardSectionTag = styled.div`
  background-color: #cac1e6;
  border-radius: 20px;
  padding: 16px 20px 16px 20px;
  display: flex;
  flex-direction: column;
  min-height: 89px;
  height: fit-content;
  max-width: 27.5rem;

  h4 {
    font-size: 20px;
    color: ${palette.brand.darkGreen};
    font-weight: 500;
    line-height: 28.8px;
    margin-bottom: 8px;
  }

  div.value {
    font-size: 14px;
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-bottom: 8px;

    p.text-icon {
      margin-bottom: 0px;
      align-self: end;
    }
  }

  p.card-text {
    text-transform: capitalize;
    color: ${palette.brand.darkPurple};
    line-height: 20.16px;
    letter-spacing: 1.6px;
    font-weight: 500;
  }

  div.full-contact {
    display: flex;
    flex-direction: row;

    .value {
      margin-bottom: 0px;
    }

    p {
      letter-spacing: 1px;
    }

    > div:nth-last-child(1) {
      margin-left: 1rem;
    }
  }
`

const displayItem = (
  item: { text: string; icon?: string },
  iconColor?: string
) => (
  <div key={item.text}>
    {item.icon ? (
      <div className="value">
        <Icon
          icon={item.icon as IconNotebook}
          color={iconColor ?? palette.brand.darkPurple}
          size="1.5rem"
        />
        <p className="card-text text-icon">{item.text}</p>
      </div>
    ) : (
      <p className="card-text text-icon">{item.text}</p>
    )}
  </div>
)

export const Card: React.FC<{
  title: string
  value: string | { text: string; icon?: string; type?: string }[]
  show?: boolean
  iconColor?: string
  isFullContact?: boolean
}> = ({ title, value, show = true, iconColor, isFullContact = false }) => {
  if (!show) {
    return null
  }

  let displayValues = value

  if (isFullContact && Array.isArray(value)) {
    displayValues = value.filter(el => el?.type !== 'contact')
  }

  return (
    <CardSectionTag>
      <h4>{title}</h4>
      <div id="test">
        {Array.isArray(displayValues) ? (
          displayValues.map(item =>
            displayItem(
              {
                text: item.text?.toUpperCase(),
                icon: item.icon,
              },
              iconColor
            )
          )
        ) : (
          <p className="card-text">{displayValues?.toUpperCase()}</p>
        )}

        {!!isFullContact && Array.isArray(value) && (
          <div className="full-contact">
            {displayItem({
              text: value[value.length - 2].text?.toUpperCase(),
              icon: value[value.length - 2].icon,
            })}
            {displayItem({
              text: value[value.length - 1].text?.toUpperCase(),
              icon: value[value.length - 1].icon,
            })}
          </div>
        )}
      </div>
    </CardSectionTag>
  )
}
